import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDropzone } from "react-dropzone";

const EditFooterApp = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const [formData, setFormData] = useState({
    link: "",
    image: null,
    preview: "",
  });

  // Fetch existing footer app data
  useEffect(() => {
    axios
      .get(`${baseUrl}/footers/app/${id}`)
      .then((res) => {
        const data = res.data.data;
        setFormData({
          link: data.link,
          preview: data.image,
          image: null,
        });
      })
      .catch((err) => console.error("Error fetching footer app data:", err));
  }, [id, baseUrl]);

  // Dropzone handler
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setFormData({
          ...formData,
          image: file,
          preview: URL.createObjectURL(file),
        });
      }
    },
    [formData]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("link", formData.link);
      if (formData.image) data.append("image", formData.image);

      await axios.post(`${baseUrl}/footers/app/update/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Footer App updated successfully!");
      navigate("/settings/footer");
    } catch (err) {
      console.error("Update failed:", err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="main-container container-fluid p-5">
      <div className="page-header mb-4">
        <h1 className="page-title text-xl font-semibold">
          Update Footer App Details
        </h1>
      </div>

      <form
        onSubmit={handleSubmit}
        className="card p-5 shadow-sm border rounded-xl"
        encType="multipart/form-data"
      >
        {/* Image Upload */}
        <div className="mb-6">
          <label className="form-label font-medium mb-2 block">Image</label>
          <div className="flex flex-wrap items-center gap-6">
            <div
              {...getRootProps()}
              className={`border-2 border-dashed rounded-xl w-[220px] h-[180px] flex flex-col items-center justify-center cursor-pointer ${
                isDragActive
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-300 bg-gray-50"
              }`}
            >
              <input {...getInputProps()} />
              {formData.preview ? (
                <img
                  src={formData.preview}
                  alt="Preview"
                  className="w-full h-full object-cover rounded-xl"
                />
              ) : (
                <div className="text-center text-gray-500">
                  <p>Drag & drop or click</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* App Link */}
        <div className="mb-5">
          <label className="form-label font-medium mb-2 block">App Link</label>
          <input
            type="text"
            className="form-control border rounded-md p-2 w-full"
            name="link"
            value={formData.link}
            onChange={handleChange}
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
        >
          Update
        </button>
      </form>
    </div>
  );
};

export default EditFooterApp;

